import { ProductPayment } from '../types/transactionTypes';

interface AdditionalInformationItem {
    question: string;
    answer: string;
}

export function TransactionAdditionalInfo({ paymentData }: { paymentData: ProductPayment }) {
    const hasNote = paymentData.data?.note;
    const hasAdditionalInfo =
        paymentData.data?.additional_information && paymentData.data.additional_information.length > 0;

    // Filter additional information to only show items with answers
    const collectedInformation: AdditionalInformationItem[] = hasAdditionalInfo
        ? paymentData.data.additional_information.filter((info: AdditionalInformationItem) => !!info.answer)
        : [];

    if (!hasNote && collectedInformation.length === 0) {
        return null;
    }

    return (
        <div className='flex w-full flex-col flex-wrap items-start gap-4 p-0 md:flex-row'>
            {hasNote && (
                <div className='flex w-full flex-col gap-1 p-0 md:w-1/2'>
                    <h4 className='text-gray mb-1 text-sm font-semibold'>Customer Note</h4>
                    <p className='text-dark m-0 text-sm'>{paymentData.data.note}</p>
                </div>
            )}
            {collectedInformation.length > 0 && (
                <div className='flex w-full flex-col gap-5 p-0 md:w-full'>
                    {collectedInformation.map((info: AdditionalInformationItem) => (
                        <div key={`info-${info.question}`} className='flex flex-col gap-1'>
                            <h4
                                className='text-gray mb-1 text-sm font-semibold'
                                dangerouslySetInnerHTML={{ __html: info.question }}
                            />
                            <p className='text-dark m-0 text-sm'>{info.answer}</p>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}
